import TooltipHandler from '../../assets/index'

export default function (elements?: NodeListOf<HTMLElement> | string): () => void {
  const controller = new AbortController()
  const { signal } = controller
  const initializedTooltips: HTMLElement[] = []

  let tooltipElements = elements || '[data-tooltip-id]'

  if (typeof tooltipElements === 'string') {
    tooltipElements = document.querySelectorAll<HTMLElement>(tooltipElements)
  }

  tooltipElements.forEach((el) => {
    const id = el.getAttribute('data-tooltip-id')

    if (!id) {
      return
    }

    const tooltipEl = document.querySelector<HTMLElement>(`.o-tooltip[data-id="${id}"]`)

    if (!tooltipEl || tooltipEl?.hasAttribute('data-tooltip-init')) {
      return
    }

    const tooltip = new TooltipHandler({
      el,
      tooltipEl,
      arrowEl: tooltipEl.querySelector<HTMLElement>('.o-tooltip__arrow') as HTMLElement,
      onHide: (tooltipEl) => {
        tooltipEl.setAttribute('hidden', 'true')
      },
      onShow: (tooltipEl) => {
        tooltipEl.removeAttribute('hidden')
      },
    })

    tooltipEl.setAttribute('data-tooltip-init', 'true')
    initializedTooltips.push(tooltipEl)

    tooltip.bind(signal)
  })

  return () => {
    controller.abort()
    initializedTooltips.forEach((tooltipEl) => {
      tooltipEl.removeAttribute('data-tooltip-init')
    })
  }
}
